import { useEffect, useState } from "react";
import { Divider, FormGroup, Grid } from "@mui/material";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { numberWithCommas } from "../../../../utils/utility";
import { useTranslation } from "react-i18next";

//import general components
import BaseCheckbox from "../../../common/base-checkbox/base-checkbox";

function PassengerInformation({ passenger }) {
    return (
        <Grid container item xs="auto" direction="column">
            <span className="order-details-modal__passenger-name">
                {passenger?.first_name || passenger?.english_first_name} {passenger?.last_name || passenger?.english_last_name}
            </span>
            <Grid container item xs="auto">
                <span className="order-details-modal__passenger-national">
                    {passenger.national_id || passenger?.national_code || passenger?.passport_number}
                </span>
                <span className="order-details-modal__order-price">{numberWithCommas(passenger.total_price)} ریال</span>
            </Grid>
        </Grid>
    );
}

function OrderPassengers({ orderItem, isCancellationRequest }) {
    //general
    const [parent] = useAutoAnimate();
    const { t } = useTranslation();

    //handle passenger change
    const [selectedPassenger, setSelectedPassenger] = useState({});
    useEffect(() => {
        setSelectedPassenger(orderItem?.passengers?.reduce((acc, cur) => ({ ...acc, [cur.id]: false }), {}));
    }, [orderItem]);

    const handleChange = event => {
        setSelectedPassenger({
            ...selectedPassenger,
            [event.target.name]: event.target.checked,
        });
    };

    return (
        <Grid container item xs={12} rowGap={1}>
            <Grid container item xs={12}>
                <span className="order-details-modal__title">{t("passengersInformation")}</span>
            </Grid>
            {orderItem?.passengers?.map(passenger => {
                return (
                    <Grid key={passenger?.id} container item xs={12}>
                        <FormGroup sx={{ width: "100%" }}>
                            <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                                {isCancellationRequest ? (
                                    <Grid container item xs={9} md={8}>
                                        <BaseCheckbox
                                            key={passenger?.id}
                                            label={<PassengerInformation passenger={passenger} />}
                                            name={`${passenger?.id}`}
                                            checked={selectedPassenger[passenger?.id]}
                                            handleChange={handleChange}
                                            disabled={passenger?.canceled?.key !== 0}
                                        />
                                    </Grid>
                                ) : (
                                    <Grid container item xs={9} md={8} ref={parent}>
                                        <PassengerInformation passenger={passenger} />
                                    </Grid>
                                )}
                                <Grid
                                    className={`order-details-modal__canceled${passenger?.canceled?.key}`}
                                    container
                                    item
                                    xs={2}
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    {passenger?.canceled?.value}
                                </Grid>
                            </Grid>
                        </FormGroup>
                        <Divider width="100%" sx={{ borderBottomColor: "var(--medium-gray-color)" }} />
                    </Grid>
                );
            })}
        </Grid>
    );
}

export default OrderPassengers;
